<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img
                    class="img-fluid for-light"
                    src="../assets/images/logo/rentycloudy-sm.png"
                    alt="looginpage"
                  />
                  <img
                    class="img-fluid for-dark"
                    src="../assets/images/logo/logo_dark.png"
                    alt="looginpage"
                  />
                </a>
              </div>
              <div class="login-main">
                <b-card no-body>
                  <b-tabs pills vertical>
                    
                    <b-tab>
                      <template #title>
                        <img src="../assets/images/login/jwt.svg" />
                        <span>JWT</span>
                      </template>
                      <b-card-text>
                        <div class="alert alert-info">
                          Please provide user credentials to log in.
                        </div>
                        <form class="theme-form" @submit.prevent="handleSubmit">
                          <div class="form-group">
                            <label for="username">Username</label>
                            <input
                              type="text"
                              v-model="jwt.identifier"
                              name="username"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !jwt.identifier }"
                            />
                            <div
                              v-show="submitted && !jwt.identifier"
                              class="invalid-feedback"
                            >
                              Username is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                              type="password"
                              v-model="jwt.password"
                              name="password"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && !jwt.password,
                              }"
                            />
                            <div
                              v-show="submitted && !jwt.password"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                          </div>
                          <div class="form-group mt-3 mb-0">
                            <button
                              class="btn btn-primary btn-block"
                              :disabled="loggingIn"
                            >
                              Login
                            </button>
                          </div>
                          <p class="mt-4 mb-0">
                            Don't have account?
                            <router-link class="ml-2" tag="a" to="/auth/register" >
                            Create Account
                          </router-link>
                          </p>
                        </form>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>

<script>
import Userauth from "../auth/js/index";
export default {
  name: "login",
  data() {
    return {
      type: "password",
      email: "test@admin.com",
      password: "test@123456",
      submitted: false,
      jwt: {identifier: '', password: ''}
    };
  },
  computed: {
    // JWT authentication
    loggingIn() {
      // return this.$store.state.authentication.status.loggingIn;
    },
  },
  mounted() {
    // reset login status for JWT
    // this.$store.dispatch("authentication/logout");

    if(localStorage.getItem('user')){
     this.$store.dispatch('auth/tryLogin')
     console.log('trying autologin')
    }
  },
  methods: {
    // JWT authentication
    handleSubmit(e) {
      this.submitted = true;
      const identifier = this.jwt.identifier;
      const password = this.jwt.password;
      const { dispatch } = this.$store;
      if (identifier && password) {
        dispatch("auth/login", {identifier, password});
      }
    },
    // show/hide password
    showPassword: function () {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },

    // Auth0 login
    login() {
      Userauth.login();
    },
  },
};
</script>